import { render, staticRenderFns } from "./DoctorDetail.vue?vue&type=template&id=17181526&scoped=true"
import script from "./DoctorDetail.vue?vue&type=script&lang=js"
export * from "./DoctorDetail.vue?vue&type=script&lang=js"
import style0 from "./DoctorDetail.vue?vue&type=style&index=0&id=17181526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17181526",
  null
  
)

export default component.exports